<template>
   <div>
      <navbar-component />
      <main class="bg-blueGray-100">
         <section
            class="relative overflow-hidden pt-16 py-24 md:py-32"
            :style="{ backgroundColor: '#111827' }"
         >
            <div class="container relative mx-auto px-4 md:px-6">
               <div class="max-w-2xl mx-auto text-center">
                  <p
                     class="text-blue-400 text-sm font-bold tracking-wider uppercase mb-4"
                  >
                     404
                  </p>
                  <h1
                     class="text-white font-bold text-4xl md:text-5xl leading-tight mb-5"
                  >
                     Page not found
                  </h1>
                  <p class="text-blueGray-300 text-lg leading-relaxed mb-8">
                     That URL doesn�t match a page on the AMI site. Head home or
                     jump to a product below.
                  </p>
                  <div class="flex flex-wrap gap-3 justify-center">
                     <router-link
                        to="/"
                        class="inline-block bg-blue-600 hover:bg-blue-500 text-white font-bold py-3 px-6 rounded-lg transition-colors duration-200"
                     >
                        Back to home
                     </router-link>
                     <router-link
                        to="/mpc"
                        class="inline-block bg-transparent hover:bg-blueGray-800 text-white font-bold py-3 px-6 rounded-lg border border-blueGray-500 transition-colors duration-200"
                     >
                        Datavan MPC
                     </router-link>
                     <router-link
                        to="/wavecommand7"
                        class="inline-block bg-transparent hover:bg-blueGray-800 text-white font-bold py-3 px-6 rounded-lg border border-blueGray-500 transition-colors duration-200"
                     >
                        WaveCommand7
                     </router-link>
                  </div>
               </div>
            </div>
         </section>
      </main>
      <footer-component />
   </div>
</template>

<script>
import NavbarComponent from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
import { setPageSeo } from "@/utils/seo";

export default {
   name: "NotFound",
   components: {
      NavbarComponent,
      FooterComponent,
   },
   mounted() {
      // Keep unknown URLs out of the index; do not soft-404 as the homepage.
      setPageSeo({
         title: "Page Not Found | AMI",
         description:
            "This page was not found on the Advanced Measurements website. Return home or browse AMI frac control products.",
         path: this.$route.path,
         robots: "noindex, follow",
         jsonLd: null,
      });
   },
};
</script>
